import { useContext, useEffect, useState } from "react";
import {
  CustomButton2,
  CustomView,
  ImageUploader,
} from "../../../../../../components";
import "./index.scss";
import Context from "../../../../../../context";
import constants from "../../../../../../values/constants";
import Cookies from "js-cookie";
import { uploadImage } from "../../../../../../api/method.post/common";

type Props = {
  data?: any;
};

const Body = ({ data }: Props) => {
  // ============================================= Value Validation ==================================================
  const { userInfo } = useContext(Context.UserScreen);

  const documents = userInfo?.companyInformation?.documents;

  // const documents = JSON.parse(
  //   Cookies.get(constants?.USER?.COMPANY_DOCUMENTS) as string
  // );

  console.log(documents);
  const [selectedNationalCardImage, setSelectedNationalCardImage] =
    useState<any>({ link: documents?.nationalCardFront });
  const [selectedNationalCardBackImage, setSelectedNationalCardBackImage] =
    useState<any>({ link: documents?.nationalCardBack });
  const [selectedCompanyLicense, setSelectedCompanyLicenseImage] =
    useState<any>({ link: documents?.companyLicence });

  useEffect(() => {
    setSelectedCompanyLicenseImage({ link: documents?.companyLicence });
    setSelectedNationalCardBackImage({ link: documents?.nationalCardBack });
    setSelectedNationalCardImage({ link: documents?.nationalCardFront });
  }, [userInfo]);

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  async function onUploadImage(
    imageFile: File,
    setImage: (image: any) => void
  ) {
    const imagePromise = await uploadImage!(imageFile);
    if (imagePromise?.CODE === 2042) setImage(imagePromise?.result);
  }

  const { submitUploadDocument, isLoading, setIsLoading } = useContext(
    Context.UploadDocumentContext
  );

  const onSubmit = () => {
    const userId = Cookies.get(constants.USER.IDENTIFY);
    submitUploadDocument({
      _id: userId,
      nationalCardFront: selectedNationalCardImage?.link,
      nationalCardBack: selectedNationalCardBackImage?.link,
      companyLicence: selectedCompanyLicense?.link,
    });
  };

  // ================================================ JSX Content ====================================================
  return (
    <section id="upload-document-container">
      <CustomView.Container>
        <CustomView.Row>
          <CustomView.Column medium={4}>
            <div className="upload-container">
              <p>تصویر کارت ملی</p>
              <div className="upload-body">
                <ImageUploader
                  defaultImage={selectedNationalCardImage}
                  setImage={setSelectedNationalCardImage}
                  uploadImage={(event: any) =>
                    onUploadImage(event, setSelectedNationalCardImage)
                  }
                />
              </div>
            </div>
          </CustomView.Column>
          <CustomView.Column medium={4}>
            <div className="upload-container">
              <p>تصویر پشت کارت ملی</p>
              <div className="upload-body">
                <ImageUploader
                  defaultImage={selectedNationalCardBackImage}
                  setImage={setSelectedNationalCardBackImage}
                  uploadImage={(event: any) =>
                    onUploadImage(event, setSelectedNationalCardBackImage)
                  }
                />
              </div>
            </div>
          </CustomView.Column>{" "}
          <CustomView.Column medium={4}>
            <div className="upload-container">
              <p>جواز شرکت</p>
              <div className="upload-body">
                <ImageUploader
                  defaultImage={selectedCompanyLicense}
                  setImage={setSelectedCompanyLicenseImage}
                  uploadImage={(event: any) =>
                    onUploadImage(event, setSelectedCompanyLicenseImage)
                  }
                />
              </div>
            </div>
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row button-row">
          <CustomView.Column medium={2} className="form-col">
            <CustomButton2
              onClick={onSubmit}
              isLoading={isLoading}
              title={"ذخیره تغییرات"}
              type="info"
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Container>
    </section>
  );
};

export default Body;
